import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { HttpHelpersService, LoadingService } from '@coin/shared/core/data-access';
import { environment } from '@coin/shared/core/util-environments';
import { Observable } from 'rxjs';

import { DirectsPositionClassComparison } from '../models/directs-position-class-comparison.model';

@Injectable({
  providedIn: 'root'
})
export class DirectsPositionClassComparisonService {
  private readonly httpClient = inject(HttpClient);
  private readonly httpHelper = inject(HttpHelpersService);
  private readonly loadingService = inject(LoadingService);

  public getDirectsEvaluationMembers(
    employeeId: string,
    orgCode?: string
  ): Observable<Array<DirectsPositionClassComparison>> {
    let params = new HttpParams();
    if (orgCode) params = params.append('OrgCode', orgCode);

    const url = `${environment.api.baseUrl}/customer/api/v1/master/employees/${employeeId}/directs/position-class-comparisons`;

    return this.httpClient
      .get<DirectsPositionClassComparison[]>(url, { params })
      .pipe(
        this.httpHelper.handleError('Cannot get directs with their positionclass'),
        this.loadingService.withLoadingScreen
      );
  }
}
